import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from '../hooks/use-toast';
import { Building2, Mail, Globe, MapPin } from 'lucide-react';

const CompanyProfilePage = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState({
    companyName: 'TechCorp AI',
    email: user?.email || '',
    description: 'Leading AI company building the future of technology.',
    industry: 'Artificial Intelligence',
    size: '50-200 employees',
    website: 'https://techcorp.ai',
    location: 'San Francisco, CA'
  });

  const handleSave = () => {
    toast({
      title: 'Profile updated',
      description: 'Your company profile has been successfully updated.'
    });
  };

  return (
    <div className="min-h-screen bg-[#F9FBF5] pt-20">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Company Profile</h1>

        <Card className="p-8">
          <div className="space-y-6">
            {/* Basic Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Label htmlFor="companyName">
                  <Building2 className="w-4 h-4 inline mr-2" />
                  Company Name
                </Label>
                <Input
                  id="companyName"
                  value={profile.companyName}
                  onChange={(e) => setProfile({ ...profile, companyName: e.target.value })}
                  className="mt-2"
                />
              </div>
              <div>
                <Label htmlFor="email">
                  <Mail className="w-4 h-4 inline mr-2" />
                  Email
                </Label>
                <Input
                  id="email"
                  type="email"
                  value={profile.email}
                  disabled
                  className="mt-2 bg-gray-50"
                />
              </div>
            </div>

            {/* Description */}
            <div>
              <Label htmlFor="description">Company Description</Label>
              <Textarea
                id="description"
                value={profile.description}
                onChange={(e) => setProfile({ ...profile, description: e.target.value })}
                className="mt-2"
                rows={4}
              />
            </div>

            {/* Industry & Size */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Label htmlFor="industry">Industry</Label>
                <Input
                  id="industry"
                  value={profile.industry}
                  onChange={(e) => setProfile({ ...profile, industry: e.target.value })}
                  className="mt-2"
                />
              </div>
              <div>
                <Label htmlFor="size">Company Size</Label>
                <Input
                  id="size"
                  value={profile.size}
                  onChange={(e) => setProfile({ ...profile, size: e.target.value })}
                  className="mt-2"
                />
              </div>
            </div>

            {/* Website & Location */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Label htmlFor="website">
                  <Globe className="w-4 h-4 inline mr-2" />
                  Website
                </Label>
                <Input
                  id="website"
                  value={profile.website}
                  onChange={(e) => setProfile({ ...profile, website: e.target.value })}
                  className="mt-2"
                />
              </div>
              <div>
                <Label htmlFor="location">
                  <MapPin className="w-4 h-4 inline mr-2" />
                  Location
                </Label>
                <Input
                  id="location"
                  value={profile.location}
                  onChange={(e) => setProfile({ ...profile, location: e.target.value })}
                  className="mt-2"
                />
              </div>
            </div>

            {/* Save Button */}
            <div className="pt-6 border-t">
              <Button
                onClick={handleSave}
                className="bg-[#0A3900] hover:bg-[#1A5C0A]"
                size="lg"
              >
                Save Profile
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CompanyProfilePage;
